import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomTitle, randomWords } from '../../../utils/dummyData'
import { linkWrapper } from '../../../utils/link'
import * as WP from '../../../wordpress/blockDefinitions'
import type { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { logoWallBlockClasses, LogoWallBlockLayout } from './logoWallBlock.layout'
import type { LogoWallBlockProps, LogoWallItemProps } from './logoWallBlock.state'
import { parseDrupalImageUrls } from '../../../drupal/utils/modernImage'
import { logoWallSrcSet } from '../../../../cms/drupal/utils/imageSizes'
import type { FieldLogoItem } from './logoWallBlockItem.blockDefinition'

export const logoWallBlock: ModernBlock<LogoWallBlockProps, WP.Gutenberg.Vidda.Text, any, DP.LogoWall> = {
  kind: 'logoWallBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) => fromJSX((updateBlock) => (
    <LogoWallBlockLayout.Inner id={`logowallblock-${blockIndex}`} amountNested={amountNested!}>
      <LogoWallBlockLayout.Content
        label={blockProps.label}
        title={blockProps.title}
        intro={blockProps.intro}
        items={blockProps.items}
        showPrimary={blockProps.showPrimary}
        showSecondary={blockProps.showSecondary}
        primaryAction={blockProps.primaryAction!}
        secondaryAction={blockProps.secondaryAction!}
      />
    </LogoWallBlockLayout.Inner>
  )),
  adapters: {
    drupal: (dpBlock: DP.LogoWall, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'logo_wall_block')
        return undefined
      return {
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        showPrimary: dpBlock.target.field_links[0] ? true : false,
        showSecondary: dpBlock.target.field_links[1] ? true : false,
        primaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.options?.attributes?.id! : '',
        }),
        secondaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.options?.attributes?.id! : '',
        }),
        items: dpBlock.target.field_logo_item.map<LogoWallItemProps>((item: FieldLogoItem) => {
          // const fieldMediaImage = item.target.field_image[0]?.target.field_media_image[0]
          // const fieldMediaSource = item.target.field_image[0]?.target.field_source[0]
          //   ? dpBlock.target.field_image[0]?.target.field_source
          //   : undefined
          // const dpImages = fieldMediaImage
          //   ? parseDrupalImageUrls(fieldMediaImage, fieldMediaSource, textImageSrcSet)?.image
          //   : undefined
          const fieldMediaImage = item.target.field_media[0]?.target.field_media_image[0]
          const fieldMediaSource = item.target.field_media[0]?.target.field_source[0]
            ? item.target.field_media[0]?.target.field_source
            : undefined
          const dpLogo = fieldMediaImage
            ? parseDrupalImageUrls(fieldMediaImage, fieldMediaSource, logoWallSrcSet)?.image
            : undefined
          return {
            link: { 
              url: item.target.field_url ? (item.target.field_url.length > 0 ? item.target.field_url[0].processed_url : '') : '',
              title: item.target.field_url ? (item.target.field_url.length > 0 ? item.target.field_url[0].title : '') : '',
              target: '_blank',
              kind: 'link'
            },
            logo: dpLogo,
            name: item.target.field_label ? (item.target.field_label.length > 0 ?  item.target.field_label[0].value : '') : '',
          } 
        }),
        anchorTitle: dpBlock.target.field_title ? (dpBlock.target.field_title.length > 0 ? dpBlock.target.field_title[0]?.value : '') : '',
        inviewState: false
      }
    }
  },
  sampleExample: [
    {
      title: randomTitle(),
      label: randomWords(),
      intro: dummyData.intro,
      items: [
        {
          name: randomWords(),
          logo: dummyData.image,
          link: {
            url: '',
            title: randomWords(),
            target: '_blank',
            kind: 'link'
          }
        },
        {
          name: randomWords(),
          logo: dummyData.image,
        },
        {
          name: randomWords(),
          logo: dummyData.image,
          link: {
            url: '',
            title: randomWords(),
            target: '_blank',
            kind: 'link'
          }
        },
        {
          name: randomWords(),
          logo: dummyData.image,
        },
        {
          name: randomWords(),
          logo: dummyData.image,
          link: {
            url: '',
            title: randomWords(),
            target: '_blank',
            kind: 'link'
          }
        },
        {
          name: randomWords(),
          logo: dummyData.image,
        },
        {
          name: randomWords(),
          logo: dummyData.image,
          link: {
            url: '',
            title: randomWords(),
            target: '_blank',
            kind: 'link'
          }
        },
        {
          name: randomWords(),
          logo: dummyData.image,
        },
        {
          name: randomWords(),
          logo: dummyData.image,
          link: {
            url: '',
            title: randomWords(),
            target: '_blank',
            kind: 'link'
          }
        },
      ],
      anchorTitle: 'logowall-sample-1',
      showPrimary: true,
      showSecondary: true,
      primaryAction: dummyData.primaryButton,
      secondaryAction: dummyData.secondaryButton
    }
  ],
  seoEvents: (props: any, blockIndex: any) => [
    props.showPrimary && props.primaryAction
      ? {
        id: `primary_button`,
        event: 'onClick',
        category: 'logowall_block',
        label: window.location.pathname,
        action: 'primary_' + props.primaryAction.title
      }
      : undefined,
    props.showSecondary && props.secondaryAction
      ? {
        id: `secondary_button`,
        event: 'onClick',
        category: 'logowall_block',
        label: window.location.pathname,
        action: 'secondary_' + props.secondaryAction.title
      }
      : undefined
  ].filter((i) => i != undefined) as SeoEvent[],
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(logoWallBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState: any, currentBlockState: any) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(logoWallBlockClasses, 'block', 'mb-6')
}
